// Custom Advance Search Code
 
document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('advancedSearchForm');
  const results = document.getElementById('advSearchResults');
  let loading = false;

  if (!form || !results) return;

  function buildUrl() {
    const fd = new FormData(form);
    const params = new URLSearchParams();

    for (const [k, v] of fd.entries()) {
      if (v) {
        params.append(k, v);}
    }
console.log(params);console.log(decodeURIComponent(params.toString()));
    return `/search?${decodeURIComponent(params.toString())}`;
  }

  function fetchResults(url, append = false) {
    if (loading) return;
    loading = true;

    fetch(url)
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newResults = doc.querySelector('#advSearchResults');

        if (!newResults) return;

        if (append) {
          const grid = results.querySelector('.adv-grid');
          newResults.querySelectorAll('.adv-card').forEach(c => grid.appendChild(c));
          results.querySelector('.adv-load-more')?.remove();
          const lm = newResults.querySelector('.adv-load-more');
          if (lm) results.appendChild(lm);
        } else {
          results.innerHTML = newResults.innerHTML;
        }

        history.replaceState({}, '', url);
      })
      .finally(() => loading = false);
  }

  form.addEventListener('submit', e => {
    e.preventDefault();
    fetchResults(buildUrl());
  });

  form.querySelectorAll('select').forEach(sel => {
    sel.addEventListener('change', () => fetchResults(buildUrl()));
  });
   /* document.getElementsByClassName('filter_check').addEventListener('click', e => {
  e.preventDefault();
    fetchResults(buildUrl());
    form.submit();
  });*/
const elements = document.getElementsByClassName('filter_check');console.log(elements);
for (const el of elements) {
    el.addEventListener('click', () => fetchResults(buildUrl()));
}
  /* form.querySelectorAll('checkbox').forEach(sel => {
    alert('hello');
    sel.addEventListener('click', () => fetchResults(buildUrl()));
  });*/

  window.addEventListener('scroll', () => {
    const lm = document.querySelector('.adv-load-more');
    if (!lm || loading) return;

    if (lm.getBoundingClientRect().top < window.innerHeight + 200) {
      fetchResults(lm.dataset.nextUrl, true);
    }
  });
});



// Only on select one checkbox at a time
document.addEventListener('DOMContentLoaded', function () {
  const checkboxes = document.querySelectorAll('.product-filter-toggle');
  const allFilterSections = document.querySelectorAll('.extra-filters');

  checkboxes.forEach(cb => {
    cb.addEventListener('change', function () {

      allFilterSections.forEach(section => {
        section.classList.remove('active');
      });

      checkboxes.forEach(other => {
        if (other !== this) {
          other.checked = false;
        }
      });

      if (this.checked && this.dataset.target) {
        const target = document.getElementById(this.dataset.target);
        if (target) {
          target.classList.add('active');
        }
      }
    });
  });

});


// Remove extra filter selection.
document.addEventListener('DOMContentLoaded', function () {

  const mainFilterSelectors = [
    'select[name^="filter.p.m.custom.new_torque"]',
    'select[name^="filter.p.m.custom.new_rpm"]',
    'select[name^="filter.p.m.custom.new_horsepower"]'
  ];

  const productTypeCheckboxes = document.querySelectorAll('.product-filter-toggle');
  const extraFilterSections = document.querySelectorAll('.extra-filters');

  function resetExtraFilters() {
    // Uncheck product-type checkboxes
    productTypeCheckboxes.forEach(cb => {
      cb.checked = false;
    });

    // Hide extra filter sections
    extraFilterSections.forEach(section => {
      section.classList.remove('active');
    });

    // Reset selects inside extra filters
    extraFilterSections.forEach(section => {
      section.querySelectorAll('select').forEach(select => {
        select.selectedIndex = 0;
      });
    });
  }

  // Attach change listener to main filters
  mainFilterSelectors.forEach(selector => {
    const el = document.querySelector(selector);
    if (!el) return;

    el.addEventListener('change', () => {
      resetExtraFilters();
    });
  });

});
